const setAlert = ({ commit }, object) => {
  const { message, status } = object;
  commit("SET_ALERT", { message, status });
};

export default {
  setAlert,
};
